import styled from 'styled-components';
import {
    Button,
} from 'antd';

export const Container = styled.div`
  margin: 30px auto;
  max-width: 50vw;
  width: 80%;
font-family: system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;

@media only screen and (max-width: 600px) {
    max-width: 100vw;
    width: 90%;
}
`;

export const styleButton = styled(Button)`
    background: transparent;
    color: white;
    font-size: 1em;
    margin: .5em;
    padding: 0.5em 1em;
    border: 1px solid white;
    border-radius: 25px;
    height: 5vh;

    &:hover {
        color: #ad5389;
        background: white;
        border: 2px solid white;
    }

    &:focus {
        color: #ad5389;
        background: white;
        border: 2px solid white;
    }
`;

export const Title = styled.h1`
    color: white;
    font-weight: bold;
    text-align: center;
`;

export const Description = styled.p`
    color: white;
    font-weight: normal;
    text-align: center;
    letter-spacing: 0.1em;
`;

export const Footer = styled.p`
    color: white;
    font-weight: lighter;
    text-align: center;
    letter-spacing: 0.1em;
    margin-top: 1em;
`;